// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ProcessTag = {
  BuildingFloodRisk: "building_flood_risk",
  CalculateDrainagePattern: "calculate_drainage_pattern",
  CalculateFloorLevel: "calculate_floor_level",
  ComputeMaxWaterdepth: "compute_max_waterdepth",
  Create2dFloodModel: "create_2d_flood_model",
  CreateBasicHydroData: "create_basic_hydro_data",
  DefineStudyArea: "define_study_area",
  DelineateBasins: "delineate_basins",
  ExtractDataset: "extract_dataset",
  ModelTracker: "model_tracker",
  RanaDtacogoV1: "rana-dtacogo-v1",
  SimulateRainfall: "simulate_rainfall",
  SimulateRainfallStandardEvents: "simulate_rainfall_standard_events",
  SimulationTracker: "simulation_tracker",
} as const;
export type ProcessTag = (typeof ProcessTag)[keyof typeof ProcessTag];

export function instanceOfProcessTag(value: any): boolean {
  for (const key in ProcessTag) {
    if (Object.prototype.hasOwnProperty.call(ProcessTag, key)) {
      if (ProcessTag[key as keyof typeof ProcessTag] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ProcessTagFromJSON(json: any): ProcessTag {
  return ProcessTagFromJSONTyped(json, false);
}

export function ProcessTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessTag {
  return json as ProcessTag;
}

export function ProcessTagToJSON(value?: ProcessTag | null): any {
  return value as any;
}

export function ProcessTagToJSONTyped(value: any, ignoreDiscriminator: boolean): ProcessTag {
  return value as ProcessTag;
}
